$(document).on('click', '.js-menu-toggle', function(){
	$(this).toggleClass('open');
});
$(document).on('click', '.js-submenu-toggle', function(){
	$(this).find('.js-submenu').slideToggle();
	$(this).toggleClass('submenu-open');
});